//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { IUrlRouterProvider } from 'angular-ui-router';

import { galleryPickerActions } from '@galleries/actions/galleriesPickerActions';
import { FAKE_BAZAARVOICE_NETWORK_CONTAINER_ID } from '@galleries/constants/galleriesConstants';

import {
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  hasAllFeatures,
  hasFeature,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  urlRouterProvider.when('/touchpoints/galleries', '/galleries/website');
  urlRouterProvider.when('/touchpoints/email', '/galleries/email');
  urlRouterProvider.when('/touchpoints/instashop', '/galleries/instashop');
}

export const states = {
  galleries: StateFactory({
    url: '/galleries/website',
    template: componentNameToTemplate('galleriesPage'),
    data: {
      title: 'Galleries',
      navGroup: NavGroup.COMMERCE,
      hasAccess: () =>
        hasAllFeatures('galleries') ||
        (hasAllFeatures(FeatureNames.BazaarvoiceNetworkSyndicationFrontend) &&
          !hasAllFeatures(FeatureNames.Instashop)),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.galleries',
        () => import('app/galleries/GalleriesApp'),
      ),
    },
  }),
  syndicationNetwork: StateFactory({
    url: '/galleries/website',
    template: componentNameToTemplate('galleriesPage'),
    data: {
      title: 'Galleries',
      navGroup: NavGroup.COMMERCE,
      hasAccess: () =>
        hasAllFeatures('galleries') ||
        (hasAllFeatures(FeatureNames.BazaarvoiceNetworkSyndicationFrontend) &&
          !hasAllFeatures(FeatureNames.Instashop)),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.galleries',
        () => import('app/galleries/GalleriesApp'),
        ($ngRedux) => {
          /**
           * In order to select the syndication network, we have to choose the appropriate gallery id.
           * We should do it with Redux, but for some reason, Redux uses the default value.
           * We have to wait a couple of milliseconds to overwrite it.
           *
           */
          setTimeout(() => {
            // TODO: PD-256663: Move galleries.routes.ts related nav components to styled RouteAnchors that allow us to pass the necessary params
            $ngRedux.dispatch(
              galleryPickerActions.selectGallery(
                FAKE_BAZAARVOICE_NETWORK_CONTAINER_ID,
              ),
            );
          }, 50);
        },
      ),
    },
  }),

  emailBuilder: StateFactory({
    url: '/galleries/email',
    template: componentNameToTemplate('emailBuilderPage'),
    data: {
      title: 'Email Gallery Builder',
      navGroup: NavGroup.COMMERCE,
      hasAccess: () => hasFeature('email_builder'),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.emailBuilder',
        () => import('app/email-builder/EmailBuilderApp'),
      ),
    },
  }),

  instashop: StateFactory({
    url: '/galleries/instashop',
    template: componentNameToTemplate('galleriesPage'),
    data: {
      title: 'InstaShop',
      navGroup: NavGroup.COMMERCE,
      hasAccess: () => hasAllFeatures(FeatureNames.Instashop),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.galleries',
        () => import('app/galleries/GalleriesApp'),
      ),
    },
  }),
};
